export const PracticeAreaDropdownController = ($scope, practiceAreaService) => {
  // $('.bootstrapDropdown').click(stopEventExecution)
  $scope.openPracticeAreaDropDown = event => {
    event.stopPropagation()
  }

  if ($scope.allChecked) {
    practiceAreaService.initialize([], $scope.practiceAreasList, true)
  }

  $scope.selectAllPracticeArea = () => {
    practiceAreaService.selectOrDeselectAllPractices(
      $scope.practiceAreasList,
      true
    )
    updatePracticeAreaDropdown()
  }

  /** This method will expand practice area on '+' is clicked
   */
  $scope.expandChildPracticeArea = practiceArea => {
    practiceArea.showChildren = true
  }

  /** This method will collapse practice area on '-' is clicked
   */
  $scope.collapseChildPracticeArea = practiceArea => {
    practiceArea.showChildren = false
  }

  $scope.deselectAllPracticeAreas = () => {
    practiceAreaService.selectOrDeselectAllPractices(
      $scope.practiceAreasList,
      false
    )

    updatePracticeAreaDropdown()
  }

  $scope.selectPracticeArea = (selectedValue, event) => {
    console.debug('PracticeAreaDropdownController::selectPracticeArea', {
      practiceAreasList: $scope.practiceAreasList,
      selectedValue,
      event,
    })
    practiceAreaService.selectPracticeArea(
      $scope.practiceAreasList,
      selectedValue,
      event
    )
    updatePracticeAreaDropdown()
  }

  const updatePracticeAreaDropdown = () => {
    const selectedPracticeArea = practiceAreaService.setIsSelectedChildrenPracticeArea(
      $scope.practiceAreasList,
      []
    )

    console.debug(
      'PracticeAreaDropdownController::updatePracticeAreaDropdown:selectedPracticeArea',
      selectedPracticeArea
    )
    $scope.onPracticeChange({selectedPracticeArea: selectedPracticeArea})
  }
}



// WEBPACK FOOTER //
// ./scripts/shared/directives/practice-area/practice-area-dropdown.ctrl.js